import Box from '@mui/material/Box/Box';
import React from 'react';
import { useHistory } from 'react-router-dom';
import UserType from '../enum/UserType';
import UserTechAssisTrackingPerm from '../enum/UserTechAssisTrackingPerm';
import { useAuthentication } from '../reducer/authentication';

interface LogoProps extends React.SVGProps<SVGSVGElement> {
    size: number;
    color: string;
}

export function LogoCommbox({ size, color, ...props }: LogoProps) {
    return (
        <svg id='cbx_logo' xmlns="http://www.w3.org/2000/svg" viewBox="-30 0 360 270" width={size} height={size} {...props}>
            <g transform="translate(0.000000,270.000000) scale(0.100000,-0.100000)" fill={color} stroke="none">
                <path d="M2175 2693 c-17 -3 -529 -177 -606 -205 -15 -5 -41 -23 -58 -40 -38 -37 -44 -100 -12 -118 35 -18 76 -11 316 60 303 89 302 89 315 59 5 -13 24 -111 40 -218 34 -219 45 -249 106 -269 84 -29 228 12 270 76 29 45 15 151 -51 374 -60 203 -85 246 -160 275 -29 11 -120 15 -160 6z" />
                <path d="M1045 2325 c-44 -13 -130 -42 -191 -64 -226 -80 -290 -129 -343 -255 -30 -73 -141 -429 -141 -453 0 -7 9 -22 20 -33 24 -24 58 -19 111 16 50 34 72 79 114 234 60 223 66 239 96 265 18 14 99 46 206 80 261 84 297 107 291 186 -3 44 -3 44 -43 46 -22 1 -76 -8 -120 -22z" />
                <path d="M1554 2244 c-21 -14 -85 -71 -141 -126 -113 -111 -109 -110 -193 -58 -99 59 -164 62 -224 10 -73 -64 -69 -123 12 -202 95 -94 209 -128 297 -89 150 66 411 320 431 418 14 69 -104 99 -182 47z" />
                <path d="M1880 2099 c-50 -30 -281 -265 -323 -330 -86 -130 -72 -265 36 -359 65 -57 239 -191 281 -217 58 -37 138 -42 196 -11 64 34 110 105 110 170 0 79 -17 99 -174 202 -79 52 -146 102 -150 111 -9 24 14 61 99 155 111 123 135 157 135 197 0 19 -5 43 -10 54 -27 50 -137 66 -200 28z" />
                <path d="M722 1780 c-101 -73 -98 -145 9 -272 24 -27 30 -43 25 -61 -3 -13 -45 -69 -92 -123 -177 -201 -202 -280 -113 -347 25 -18 28 -18 62 -2 41 19 216 196 306 309 116 146 149 252 106 335 -22 44 -87 113 -145 156 -61 45 -102 46 -158 5z" />
                <path d="M2437 1597 c-155 -54 -157 -74 -72 -586 63 -380 62 -407 -3 -432 -13 -5 -195 -18 -405 -29 -210 -11 -399 -24 -420 -29 -100 -24 -159 -113 -158 -242 0 -121 61 -223 146 -249 28 -8 207 -13 576 -17 496 -5 539 -4 590 12 183 60 299 222 299 416 0 82 -23 196 -100 494 -91 355 -148 546 -175 587 -61 91 -157 117 -278 75z" />
                <path d="M1193 1301 c-29 -10 -71 -30 -93 -46 -40 -28 -178 -172 -272 -285 -126 -151 -149 -253 -76 -335 59 -68 115 -44 259 116 152 168 174 189 203 189 22 0 51 -24 140 -115 113 -115 187 -165 244 -165 54 0 115 53 156 136 34 69 34 118 -2 175 -51 79 -280 283 -369 328 -52 26 -119 27 -190 2z" />
                <path d="M297 1185 c-49 -45 -73 -99 -147 -335 -147 -469 -172 -603 -131 -695 26 -58 47 -83 81 -98 14 -6 173 -13 370 -18 335 -7 346 -7 378 13 72 44 113 132 114 243 1 77 -16 129 -53 164 l-24 23 -294 -7 -294 -8 6 54 c3 30 33 167 67 304 67 272 80 355 60 380 -7 9 -29 15 -54 15 -33 0 -48 -7 -79 -35z" />
            </g>
        </svg>
    )
}

export default function HeaderLogo() {
    const history = useHistory();
    const { user } = useAuthentication();

    function handleClick() {
        if (user?.type === UserType.Commbox && user?.tech_assis_tracking_perm !== UserTechAssisTrackingPerm.YesExclusive) {
            history.push('/system/prodEng/open');
        } else {
            history.push('/');
        }
    }


    return (
        <Box borderRadius={2} width={40} height={40}
            onClick={handleClick}
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                border: 'solid 1px transparent',
                boxSizing: 'border-box',
                '&:hover': {
                    cursor: 'pointer',
                    backgroundColor: 'rgba(0, 0, 0, 0.1)',
                }
            }}>
            <LogoCommbox size={40} color='#0c5c91' />
        </Box>
    );
}
